import SBMessageInputWrapper from '@sendbird/uikit-react/GroupChannel/components/MessageInputWrapper';
import { useGroupChannelContext } from '@sendbird/uikit-react/GroupChannel/context';
import { useCallback, useEffect } from 'react';
import { useDebouncedCallback } from 'use-debounce';

export const ChatInput = ({
    initialMessage,
    onMessageChange,
}: {
    initialMessage: string;
    onMessageChange: (msg: string) => void;
}) => {
    const { messageInputRef } = useGroupChannelContext();

    const storeMessageDraft = useDebouncedCallback(
        useCallback((e: KeyboardEvent) => {
            const messageInputElement = e.target as HTMLDivElement | null;
            if (
                messageInputElement != null &&
                messageInputElement.innerText.trim() !== ''
            ) {
                onMessageChange(messageInputElement.innerText);
            }
        }, []),
        1000,
    );

    useEffect(() => {
        const messageInputElement = messageInputRef.current;
        if (messageInputElement == null) {
            return;
        }

        // Initialize message with stored draft
        // Execute this in a set timeout to run after sendbird initializes the message input
        setTimeout(() => {
            if (messageInputElement.innerText === '') {
                messageInputElement.innerText = initialMessage;
            }
        }, 50);

        // Event listeners to store draft message and delete draft on send
        messageInputElement.addEventListener('keyup', storeMessageDraft);

        return () => {
            messageInputElement.removeEventListener('keyup', storeMessageDraft);
        };
    }, []);

    return <SBMessageInputWrapper />;
};
